<template>
  <div class="upinfo">
    <van-nav-bar
      :title="title"
      fixed
      right-text="保存"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="name" v-if=" key == 'u_name'" border clearable />
      <van-notice-bar
        v-if=" key == 'u_name'"
        wrapable
        :scrollable="false"
      >请输入正确的真实姓名，为了保障用户账户的安全只能修改一次，请慎重！！！，谢谢！</van-notice-bar>

      <van-field v-model="login_id" v-if=" key == 'u_login_id'" border clearable />
      <van-notice-bar
        v-if=" key == 'u_login_id'"
        wrapable
        :scrollable="false"
      >用户账号一年只能修改一次，请记住修改后的账号！！！，谢谢！</van-notice-bar>

      <van-field v-model="phone" type="tel" v-if=" key == 'u_phone'" border clearable />
      <van-notice-bar
        v-if=" key == 'u_phone'"
        wrapable
        :scrollable="false"
      >请输入正确真实的手机号码，为了保障用户账户的安全只能修改一次，请慎重！！！，谢谢！</van-notice-bar>
      <div class="nickname" v-if=" key == 'u_email'">
        <van-field v-model="email" placeholder="请输入邮箱" border clearable />
      </div>
      <van-notice-bar
        v-if=" key == 'u_email'"
        wrapable
        :scrollable="false"
      >请输入正确真实的邮箱，为了保障用户账户的安全只能修改一次，请慎重！！！，谢谢！</van-notice-bar>
      <!-- <van-field v-model="nickname" v-if=" key == 'u_nickname'" border clearable /> -->
      <div class="nickname" v-if=" key == 'u_nickname'">
        <div class="text">修改昵称</div>
        <van-field v-model="nickname" placeholder="请输入新昵称" border clearable />
      </div>
      <div class="nickname" v-if=" key == 'u_signature'">
        <div class="text">修改签名</div>
        <van-field
          v-model="signature"
          rows="2"
          autosize
          type="textarea"
          maxlength="30"
          placeholder="请输入个性签名"
          show-word-limit
          border
          clearable
        />
      </div>
    </van-cell-group>
    <!-- 头像专区的修改 -->
    <div class="changhimg" v-if="key == 'u_headportrait'">
      <van-cell-group class="self">
        <van-image width="200px" height="200px" round class="err-image-header" :src="head.indexOf('http')==-1?(attach_url+head):head" />
        <van-uploader capture :after-read="onSend" :before-read="beforeRead">
          <van-image
            slot="upload-icon"
            class="chimg"
            src="../../assets/img/center/photo.png"
            @click="O()"
          />
        </van-uploader>
      </van-cell-group>
      <div class="choose" v-if="key == 'u_headportrait'">
        <div class="harea">头像专区</div>
        <van-cell-group>
          <van-image
            width="50px"
            height="50px"
            round
            class="err-image-header"
            :src="attach_url+item.url"
            v-for="(item , index) in headportrait"
            :key="index+''"
            @click="setHeadportrait(item.url)"
          />
        </van-cell-group>
      </div>
    </div>
  </div>
</template>
<script>
import { chkImgType } from "@/utils/common.js";
import { compUploadImg } from "@/utils/chat.js";
export default {
	name: "UpInfo",
	data() {
		return {
		  title: "",
		  radio: "", // 性别
		  key: "",
		  login_id:"",
		  headportrait: [],
		  head: "", // 头像
		  name: "", // 名字
		  phone: "", // 手机号码
		  email: "", // 邮箱
		  nickname: "", // 昵称
		  signature: "", // 个性签名
		  photoShow: false,
		  fileList: [],
		  u_id: localStorage.getItem("u_id"),
		  token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
		  attach_url: this.Conf.serverPre,
		  userinfo: JSON.parse(localStorage.getItem("userInfo"))
		};
	},
	created() {
		var params = this.$route.query;
		this.key = params.key;
		this.title = params.title;
		this.name = params.name;
		this.login_id = params.login_id;
		this.head = params.head;
		this.phone = params.phone;
		this.email = params.email;
		this.nickname = params.nickname;
		this.radio = params.sex + "";
		this.signature = params.signature;
		if (this.key == "u_headportrait") {
			this.getHeadportrait();
		}
		this.getStateConfigs();
	},
	methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		getHeadportrait() {
		  var params = {
			u_id: this.u_id,
			token: this.token,
			u_headportrait: this.userinfo.u_headportrait
		  };
		  var url =
			this.Conf.serverUrl + "User/getHeadportrait" + "?num=" + Math.random();
		  this.$axios
			.get(url, this.$qs.stringify(params))
			.then(response => {
			  this.headportrait = response.data.result;
			})
			.catch(error => {});
		},
		// 返回
		onClickLeft() {
		  this.$router.push({ path: "/MyInfo" });
		},
		// 保存
		onClickRight() {
			var params = {
				u_id: this.u_id,
				token: this.token,
				key: this.key
			};
			if (this.head) {
				params.value = this.head;
			}
		  if (this.radio && this.radio != "undefined") {
				params.value = this.radio;
		  }
		  if (this.phone) {
			if (!/^1[3456789]\d{9}$/.test(this.phone)) {
			  this.$toast.fail("请填写正确的手机号码");
			} else {
				params.value = this.phone;
			}
		  }
		  if (this.email) {
			if (
			  !/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(
				this.email
			  )
			) {
			  this.$toast.fail("请填写正确的邮箱");
			} else {
				params.value = this.email;
			}
		  }
		  //昵称
		  if (this.nickname) {
				params.value = this.nickname;
		  }
		  if (this.signature) {
				params.value = this.signature;
		  }
		  if (this.name) {
				params.value = this.name;
		  }
		  if (this.login_id) {
				params.value = this.login_id;
		  }
		  var url =
			this.Conf.serverUrl + "User/updateUserInfo" + "?num=" + Math.random();
		  this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
			  switch (response.data.code) {
				case 200:
				  var userInfo = JSON.parse(localStorage.getItem("userInfo"));
				  for (var key in userInfo) {
					if (key == params.key) {
					  userInfo[key] = params.value;
					  if(key == 'u_login_id'){
						userInfo['u_upflag'] = 0;
					  }
					}
				  }
				  localStorage.setItem("userInfo", JSON.stringify(userInfo));
				  this.userinfo = userInfo;
				  this.$toast.success(response.data.msg);
				  this.onClickLeft();
				  break;
				case 40001:
				  this.$toast.fail(response.data.msg);
				  break;
			  }
			})
			.catch(error => {
			  // this.$toast.fail("已存在，换一个再试！");
			});
		},
		setHeadportrait(url) {
		  this.head = url;
		},
		beforeRead(file) {
		  return chkImgType(file);
		},
		photo() {
		  this.photoShow = true;
		},
		// 上传图片
		onSend(file) {
		  let that = this;
		  compUploadImg(file, function(f) {
			let data = {};
			data.message = f;
			data.friend_id = that.friend_id;
			data.u_id = that.u_id;
			data.mk = 3;
			data.type = "image";
			var url =
			  that.Conf.serverUrl + "Chat/uploadImg" + "?num=" + Math.random();
			that.$axios
			  .post(url, that.$qs.stringify(data))
			  .then(response => {
				if (response.data.imageUrl) {
				  that.head = response.data.imageUrl;
				} else if (response.data.msg) {
				  that.$toast(response.data.msg);
				}
			  })
			  .catch(error => {});
		  });
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/My/UpInfo.vue